// extracted by mini-css-extract-plugin
export default {"container":"Transection_container__wX2nm","wrapperButton":"Transection_wrapperButton__rHINQ","box":"Transection_box__mD96b"};